<template>
<div class="card shadow mb-4">
  <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
    <h6 class="m-0 font-weight-bold">{{ $t('Production_Consumption_Weekdays_Weekends') }}</h6>
    <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="$t('home_tooltip_months')"></i>
  </div>

  <div class="card-body text-center">
    <LoadingSpinner v-if="loading"></LoadingSpinner>
    <div v-show="!loading" id="canvas-monthchart"></div>
  </div>
</div>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue'

export default {
  name: 'MonthChart',
  components: {
    LoadingSpinner
  },
  data(){
    return {
      chart: null,
      sec: 0,
      clock: null,
      shortdays: {
        en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        pt: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
      } 
    }  
  },
  mounted(){
    $('[data-toggle="tooltip"]').tooltip()
    const self = this
    this.chart = Highcharts.chart('canvas-monthchart', {
      chart: {
        type: 'column',
        backgroundColor: '#fff'
      },
      credits: { enabled: false },
      title: {
        text: ''
      },
      xAxis: {
        categories: [],
        type: "category"
      },
      yAxis: {
        allowDecimals: false,
        min: 0,
        title: {
          text: null
        }
      },
      tooltip: {
        shared: true,
        xDateFormat: '%A, %d %b, %H:%M',
        pointFormat: '<br/><span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y:.2f}</b> kWh'
      },
      series: [{
        name: this.$i18n.t('Consumption'),
        data: [],
        color: '#f7882f'
      }, {
        name: this.$i18n.t('Production'),
        data: [],
        color: '#4187c7'
      },
      {
        name: this.$i18n.t('Production_not_used'),
        data: [],
        color: '#53c8eb'
      }],
      plotOptions: {
        series: {
          events: {
            legendItemClick: function () {
              if (this.visible) _paq.push(['trackEvent', 'Geral', 'Gráfico Dias de semana/Fins-de-semana', 'Esconder (' + this.name + ')'])                        
              else _paq.push(['trackEvent', 'Geral', 'Gráfico Dias de semana/Fins-de-semana', 'Mostrar (' + this.name + ')'])
            },
            mouseOver: function () {
              self.clock = setInterval(function(){ self.sec++; }, 1000)
            },
            mouseOut: function () {
              clearInterval(self.clock);
              if (self.sec > 1) _paq.push(['trackEvent', 'Geral', 'Gráfico Dias de semana/Fins-de-semana', 'MouseOver (' + this.name + ')', self.sec])
              self.sec = 0
            }
          }
        }
      }
    })
  },
  methods: {
    set_values: function(){
      this.chart.xAxis[0].setCategories(this.data.map(r => this.convert_short_days(r.range)), false)
      /* this.chart.series[0].setData(this.data.map(r => r.consumed), false)
      this.chart.series[1].setData(this.data.map(r => r.produced), false)
      this.chart.series[2].setData(this.data.map(r => r.wasted_from_produced), false) */
      this.chart.series[0].setData(this.data.map(r => r.House), false)
      this.chart.series[1].setData(this.data.map(r => r.PV), false)
      this.chart.series[2].setData(this.data.map(r => r.PV_Grid), false)
      if(!this.chart.hasData()){
        this.chart.hideNoData()
        this.chart.showNoData(this.$i18n.t('No_Data'))
      }
      this.chart.redraw() 
    },
    convert_short_days: function(day_range){
      if (this.current_lang == 'pt') return day_range

      let days_text = day_range.split(" ")[0]
      let days_numbers = day_range.split(" ")[1]
      let first_day = days_text.split("-")[0]
      let last_day = days_text.split("-")[1]
      let shortdays = []

      let first_day_translated = this.shortdays[this.current_lang][this.shortdays["pt"].indexOf(first_day)]
      let last_day_translated = this.shortdays[this.current_lang][this.shortdays["pt"].indexOf(last_day)]

      if(!last_day_translated) return first_day_translated+" "+days_numbers
      
      return first_day_translated+"-"+last_day_translated+" "+days_numbers
    }
  },
  watch:{
    data: function(){
      this.set_values()
    },
    current_lang: function(){
      this.chart.series[0].update({name: this.$i18n.t('Consumption')}, false);
      this.chart.series[1].update({name: this.$i18n.t('Production')}, false);
      this.chart.series[2].update({name: this.$i18n.t('Production_not_used')}, false);
      this.set_values()
    }
  },
  computed: {
    data: function(){
      return this.$store.getters.data_workweeksWeekendsEnergyUsed
    },
    loading: function(){
      return this.$store.getters.data_loading
    },
    current_lang: function(){
      return this.$i18n.locale
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
